/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesFields.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Field Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, March 06, 2019 - 08:38:43 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      03/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const FieldList = Loadable({
    loader: () => import('../containers/Fields/FieldListContainer'),
    loading: Loading,
});

export const FieldForm = Loadable({
    loader: () => import('../containers/Fields/FieldEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesFields.js